import styled from 'styled-components';

export const Container = styled.div`
 height: calc(100dvh - 16px);
`;
